import React, { useState, useContext } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Input,
    Button,
    VStack,
    FormControl,
    FormLabel,
    HStack,
} from "@chakra-ui/react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/axios";

const CreateSectionModal = ({ isOpen, onClose, handleCreateSection }) => {
    const { currLocation } = useContext(AuthContext);
    const [newSection, setNewSection] = useState({ name: "" });

    const handleSubmit = async () => {
        try {
            const response = await api.get(`/section/${newSection.name}/location/${currLocation}`);
            handleCreateSection(response.data);
            onClose();
        } catch (error) {
            console.error("Error creating section:", error);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Dodajte novi odjeljak</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <FormControl>
                            <FormLabel>Naziv odjeljka</FormLabel>
                            <Input
                                placeholder="Unesite naziv odjeljka"
                                value={newSection.name}
                                onChange={(e) => setNewSection({ name: e.target.value })}
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button colorScheme="blue" onClick={handleSubmit}>Create</Button>
                        <Button onClick={onClose}>Povratak</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default CreateSectionModal;
